import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ShippingLineForm } from '@/components/forms/ShippingLineForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateShippingLinePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/shipping-lines')
  }

  const handleCancel = () => {
    navigate('/shipping-lines')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Create Shipping Line
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Add a new Shipping Line
            </Text>
          </CardHeader>
          <CardBody>
            <ShippingLineForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


